const DEVICE_TYPES = {
  FIX: "Fix",
  WIFIX: "Wifix",
  FLEXIBLE: "Flexibilis",
  WIFLEX: "Wiflex",
};

export default DEVICE_TYPES;
